export default {
  "selection": "_selection_2vgd5_1",
  "weekday": "_weekday_2vgd5_1",
  "control": "_control_2vgd5_1",
  "cell": "_cell_2vgd5_1",
  "cell-button": "_cell-button_2vgd5_1",
  "--active": "_--active_2vgd5_1",
  "--selection-range": "_--selection-range_2vgd5_1",
  "--selection-start": "_--selection-start_2vgd5_1",
  "--selection-end": "_--selection-end_2vgd5_1"
};import "ni:sha-256;s9KHzAbZP43gN_knuUxdYe8G85vTMxpuyJquhERvhx8";